/**
 * Leitura dos blocos da Home a partir do payload do `@home-info`.
 *
 * Nasceu dentro da `CapaView`, mas a coluna lateral da notícia precisa do mesmo
 * acesso: por decisão de design, o card "Em destaque" da notícia espelha o
 * bentô `mpfDestaques` da home, igual em todas as páginas de notícia.
 */

export interface BlockData {
  '@type'?: string;
  items?: unknown[];
  [key: string]: unknown;
}

export interface BlocksData {
  blocks?: Record<string, BlockData>;
  blocks_layout?: { items?: string[] };
}

export interface HomeInfoState {
  items?: {
    banner?: BlocksData;
    home?: BlocksData;
    highlights?: BlocksData;
  };
}

/**
 * Retorna o `data` do primeiro bloco de um dado `@type` na home (na ordem do
 * blocks_layout). Permite que cada seção leia conteúdo editável dos blocos da
 * Home, mantendo o esqueleto/grid fixo na view.
 */
export const getHomeBlockData = (
  home: BlocksData | undefined,
  type: string,
): BlockData | undefined => {
  const blocks = home?.blocks ?? {};
  const order = home?.blocks_layout?.items ?? Object.keys(blocks);
  const id = order.find((blockId) => blocks[blockId]?.['@type'] === type);
  return id ? blocks[id] : undefined;
};
